// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
var MenuV5 = require("../../v5/common/Components/menu/MenuV5.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var View__Jsx3 = require("../../uikit/reason/helpers/View__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");

function HeaderSearchDropdown(props) {
  return JsxRuntime.jsxs(MenuV5.Menu.make, {
              button: JsxRuntime.jsx(ButtonsV5.Button.make, {
                    className: TailwindMerge.twMerge([
                          "!border-none ml-1 mr-4 px-4 py-0 leading-normal bg-transparent block cursor-pointer relative h-full",
                          "text-inherit font-inherit appearance-none"
                        ]),
                    children: Caml_option.some(JsxRuntime.jsx(View__Jsx3.make, {
                              alignItems: "center",
                              justifyContent: "flexStart",
                              flexDirection: "row",
                              children: Caml_option.some(JsxRuntime.jsx(IconV5.make, {
                                        icon: "search",
                                        size: 22,
                                        className: "text-zinc-500"
                                      }))
                            }))
                  }),
              children: [
                JsxRuntime.jsx(MenuV5.MenuItem.make, {
                      href: "/properties?as_m=web&as_c=header_search_dropdown",
                      children: "Search properties"
                    }),
                JsxRuntime.jsx(MenuV5.MenuItem.make, {
                      href: "/client_needs?as_m=web&as_c=header_search_dropdown",
                      children: "Search buyer needs"
                    }),
                JsxRuntime.jsx(MenuV5.MenuItem.make, {
                      href: "/messages?as_m=web&as_c=header_search_dropdown",
                      children: "Search broadcast messages"
                    })
              ]
            });
}

var make = HeaderSearchDropdown;

exports.make = make;
/* IconV5 Not a pure module */
